var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScraperapiLogoNoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02429 23.3222H17.1633C18.6911 23.3222 20.1726 22.4888 20.9134 21.1462C21.7004 19.8036 21.7004 18.1369 20.9134 16.7943C20.1263 15.4517 18.6911 14.6183 17.1633 14.6183H14.6633H12.117C10.5429 14.6646 9.06136 13.8313 8.27431 12.4887C7.48726 11.1461 7.48726 9.43309 8.27431 8.09048C9.06136 6.74787 10.5429 5.91452 12.117 5.96082H21.4689",
    stroke: "#1A22E4",
    strokeWidth: 2.31485,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1545 1.70116H12.1637C9.06176 1.65486 6.19135 3.27526 4.61725 5.96048C3.04316 8.6457 3.08946 11.9328 4.61725 14.618C6.14505 17.3032 9.06176 18.9236 12.1637 18.8773H15.8674",
    stroke: "#1A22E4",
    strokeWidth: 2.31485,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1241 27.5351H17.115C21.8836 27.5351 25.6799 23.6925 25.6799 18.9702C25.6799 14.2479 21.8373 10.4053 17.115 10.4053H13.4112",
    stroke: "#1A22E4",
    strokeWidth: 2.31485,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9222 8.46119C25.2774 8.46119 26.376 7.36261 26.376 6.00745C26.376 4.65229 25.2774 3.55371 23.9222 3.55371C22.5671 3.55371 21.4685 4.65229 21.4685 6.00745C21.4685 7.36261 22.5671 8.46119 23.9222 8.46119Z",
    stroke: "#1A22E4",
    strokeWidth: 2.31485,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15369 25.8684C5.50885 25.8684 6.60743 24.7698 6.60743 23.4147C6.60743 22.0595 5.50885 20.9609 4.15369 20.9609C2.79853 20.9609 1.69995 22.0595 1.69995 23.4147C1.69995 24.7698 2.79853 25.8684 4.15369 25.8684Z",
    stroke: "#1A22E4",
    strokeWidth: 2.31485,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScraperapiLogoNoText);
export default __webpack_public_path__ + "static/media/scraperapi-logo-no-text.c4c4e8f461c3236a2f66eb0a240ea946.svg";
export { ForwardRef as ReactComponent };